import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=20e7ea9e"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports